import React, { FC } from 'react'
import styled from 'styled-components'
import { DatePicker } from '../DatePicker'
import ScheduleList from './ScheduleList'

const SideMenu: FC = () => {
  return (
    <SideMenuWrapper id="sideMenu">
      <DatePicker />
      <ScheduleList />
    </SideMenuWrapper>
  )
}

export default SideMenu

const SideMenuWrapper = styled.div`
  flex-basis: 300px;
`
